// extracted by mini-css-extract-plugin
module.exports = {"welcome":"Password_welcome__1Qlpo","email":"Password_email__2BvdS","helpForgotPassword":"Password_helpForgotPassword__1fx5u","link":"Password_link__Pydag"};